// extracted by mini-css-extract-plugin
export var text = "_2m-0";